/* Native Shopify forms remain functional without this enhancement. */
(() => {
  'use strict';
  function initProduct(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const select = root.querySelector('[data-variant-select]');
    const gallery = root.querySelector('[data-gallery]');
    const slides = gallery ? [...gallery.querySelectorAll('[data-media]')] : [];
    const thumbs = gallery ? [...gallery.querySelectorAll('[data-media-target]')] : [];
    const showMedia = id => {
      const match = slides.find(slide => slide.dataset.media === String(id));
      if (!match) return;
      slides.forEach(slide => {
        const active = slide === match;
        slide.classList.toggle('is-active', active);
        if (!active) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      thumbs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id))));
    };
    if (gallery && slides.length) {
      gallery.classList.add('is-enhanced');
      thumbs.forEach(button => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
    }
    function updateVariant(updateUrl) {
      const option = select?.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      const price = root.querySelector('[data-variant-price]');
      const compare = root.querySelector('[data-compare-price]');
      const button = root.querySelector('[data-add-button]');
      const label = root.querySelector('[data-add-label]');
      const enquiry = root.querySelector('[data-enquiry-box]');
      const quantity = root.querySelector('[data-quantity]');
      if (price) price.textContent = option.dataset.price || '';
      if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
      if (button) button.disabled = !available;
      if (label) label.textContent = available ? (root.dataset.addText || 'Add to cart') : (root.dataset.soldText || 'Sold out');
      if (enquiry) enquiry.hidden = available;
      if (quantity) {
        const min = Number(option.dataset.min) || 1;
        const step = Number(option.dataset.step) || 1;
        const max = Number(option.dataset.max) || Infinity;
        quantity.min = String(min); quantity.step = String(step);
        if (Number.isFinite(max)) quantity.max = String(max); else quantity.removeAttribute('max');
        let value = Number(quantity.value);
        if (!Number.isFinite(value) || value < min) value = min;
        value = min + Math.floor((Math.min(value, max) - min) / step) * step;
        quantity.value = String(Math.max(min, value));
      }
      if (option.dataset.mediaId) showMedia(option.dataset.mediaId);
      if (updateUrl && ['http:', 'https:'].includes(location.protocol)) {
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState(null, '', url);
      }
    }
    if (select) { select.addEventListener('change', () => updateVariant(true)); updateVariant(false); }
  }
  function openContact() {
    const panel = document.querySelector('[data-contact-panel]');
    if (panel) panel.open = true;
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-product-root]').forEach(initProduct);
    scope.querySelectorAll('[data-contact-panel]').forEach(panel => {
      if (panel.querySelector('.form-success,.form-error')) panel.open = true;
    });
    if (location.hash === '#kontakt' || location.hash.startsWith('#Contact-')) openContact();
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const enquiry = target.closest('[data-enquiry-link]');
    if (enquiry) {
      const root = enquiry.closest('[data-product-root]');
      const option = root?.querySelector('[data-variant-select]')?.selectedOptions[0];
      const subject = document.querySelector('[data-contact-panel] [data-contact-subject]');
      if (subject) subject.value = `${enquiry.dataset.productTitle || 'Quiet Spec'} / ${option?.dataset.variantTitle || option?.textContent || ''}`;
      openContact();
    }
    if (target.closest('a')?.getAttribute('href') === '#kontakt') openContact();
    document.querySelectorAll('[data-disclosure][open]').forEach(details => {
      if (!details.contains(target) || target.closest('a')) details.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-disclosure][open]').forEach(details => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
  });
  window.addEventListener('hashchange', () => { if (location.hash === '#kontakt') openContact(); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();

/* Friendly missing-image states. No image is substituted or represented as an original. */
(() => {
 const selector='.hero-image>img,.club-image>img,.journal-image>img,.drive-feature-image>img,.mood-image>img,.product-card-image>img,.quiet-image>img,.photographer-work-image>img';
 function monitor(scope=document){scope.querySelectorAll(selector).forEach(img=>{
  if(img.dataset.cdcWatched)return;img.dataset.cdcWatched='1';
  const update=()=>img.parentElement.classList.toggle('cdc-media-unavailable',img.complete&&img.naturalWidth===0);
  img.addEventListener('error',update);img.addEventListener('load',update);if(img.complete)update();
 });}
 document.addEventListener('shopify:section:load',e=>monitor(e.target));monitor();
})();
